import React from 'react';
import { Route } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Spin } from 'antd';
import { useAppStore } from '@/hooks';
import ErrorPage from '@/pages/errorPage';
import { ReqState } from '@gaodun.com/g2-live-sdk';

const BeforeRoute = observer((props: any) => {
    const appStore = useAppStore();
    if (appStore.pageStatus.state === ReqState.PENDING) {
        return (
            <div className="loading-container">
                <Spin tip={`正在加载...`} indicator={<img src="https://res.gaodunwangxiao.com/tools/2025-12-06/05907794_page_init_loading.gif" />} size="large" />
            </div>
        );
    }
    if (appStore.pageStatus.state === ReqState.ERROR || appStore.pageStatus.state === ReqState.NETWORK_ERROR) {
        return <ErrorPage type="notFound" />;
    }

    return <Route {...props} />;
});

export default BeforeRoute;
